import React from "react"
import { graphql } from "gatsby"
//STYLES
import { ContainerMob, ProductWrapper, Section } from "../utils/utils"
import { H1, H5, Text } from "../utils/typo"
import { theme } from "../utils/theme"
//COMPONENTS
import SEO from "../components/seo/SEO"
import Layout from "../layout/layout2"
import Baner from "../components/baner/Baner"
import Video from "../components/video/VideoSimple"
//DATA
import filmPl from "../assets/video/film_pl.mp4"
import filmEn from "../assets/video/film_en.mp4"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

const LogoGrupy = styled.div`
  display: flex;
  justify-content: center;
  > div {
    width: 60%;
  }
`

const About = ({ pageContext, data }) => {
  let { page } = data

  return (
    <div>
      <SEO title="Home" slug="/page3" />
      <Layout lang={pageContext.locale} slug={pageContext.slug}>
        <Baner
          image={page.baner.gatsbyImageData}
          alt="Baner - grupa kapitałowa"
          height="2rem"
        />

        <ContainerMob mt="4rem" mb="2rem">
          <ProductWrapper mt="-10rem">
            <div>
              <span>
                <H1 mb="2rem">
                  {page.locale === "pl-PL" ? "O nas" : "About us"}
                </H1>
                <H5 mt="2rem" mb="2rem">
                  {page.subHeading}
                </H5>
                <Text
                  mb="4rem"
                  dangerouslySetInnerHTML={{ __html: page.intro }}
                />
              </span>
              <GatsbyImage
                objectFit="contain"
                image={page.image.gatsbyImageData}
                alt="Elcam sp. z o. o."
              />
            </div>
          </ProductWrapper>
        </ContainerMob>

        <Section bgColor={theme.color.base3}>
          <ContainerMob>
            <Text
              mb="4rem"
              dangerouslySetInnerHTML={{ __html: page.opisGrupy }}
            />
            <LogoGrupy>
              <GatsbyImage
                objectFit="contain"
                image={page.logoGrupa.gatsbyImageData}
                alt="Elcam sp. z o. o."
              />
            </LogoGrupy>
          </ContainerMob>
        </Section>

        <ContainerMob mb="4rem" mt="4rem">
          <Video
            videoSrcURL={page.locale === "en" ? filmEn : filmPl}
            videoTitle="tyt"
          />
        </ContainerMob>
      </Layout>
    </div>
  )
}
export default About

export const query = graphql`
  query AboutQuery($locale: String!) {
    page: datoCmsAboutPage(locale: { eq: $locale }) {
      locale
      slug
      intro
      subHeading
      opisGrupy
      image {
        gatsbyImageData
      }
      logoGrupa {
        gatsbyImageData
      }
      baner {
        gatsbyImageData(aspectRatio: 3.0, layout: FULL_WIDTH)
      }
    }

    datoCmsAsset(format: { eq: "mp4" }) {
      id
      url
    }
  }
`
